export enum EQueryStringFilters {
  /** Города */
  Cities = 'cities',
  /** Департамент */
  Departments = 'departments',
  /** Специализация */
  Specializations = 'specializations',
  /** Быстрый фильтр */
  Tags = 'tags',
  /** Формат работы */
  WorkFormats = 'work_formats',
}
